import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { FaCode, FaCodepen, FaLaptopCode } from "react-icons/fa";

const Icon = [<FaCode />, <FaCodepen />, <FaLaptopCode />];

const query = graphql`
  query Services {
    allAirtable(filter: { table: { eq: "Services" } }) {
      nodes {
        data {
          title
          description
        }
      }
    }
  }
`;

const Services = () => {
  const {
    allAirtable: { nodes: services },
  } = useStaticQuery(query);

  return (
    <section className="section bg-grey">
      <div className="section-title">
        <h2>services</h2>
        <div className="underline"></div>
      </div>

      <div className={`services-center section-center`}>
        {services.map((service, index) => {
          const { title, description } = service.data;

          return (
            <article key={index} className="service">
              <div className="service-icon">{Icon[index]}</div>
              <h4>{title}</h4>
              <div className="underline"></div>
              <p>{description}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Services;
